import React from 'react'
import globalConfig from 'app/fuse-configs/globalConfig'

const Error403PageConfig = {
	settings: {
		layout: {
			config: {
				...globalConfig
			}
		}
	},
	auth: ['guest'],
	routes: [
		{
			path: '/error-403',
			component: React.lazy(() => import('./Error403Page'))
		}
	]
}

export default Error403PageConfig
